import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  btnsContainer: {
    display: 'flex',
    gap: 6,
  },
});
